import { i as e } from "./is-regexp.js";
var r = TypeError,
  o = function o(_o) {
    if (e(_o)) throw r("The method doesn't accept regular expressions");
    return _o;
  };
export { o as n };